<template>
  <router-view />
</template>

<script>
export default {
  title: "嵌套网页",
  name: 'iframe'
}
</script>

<style scoped>
</style>
